import Entity from '_entities/base/BaseEntity'

export const AddressSchema = {
    name: 'Address',
    properties: {
        full: { type: 'string' },
        short: { type: 'string' },
    },
}

class Address extends Entity {
    get schema() {
        return AddressSchema
    }

    static fieldLabels = {
        full: 'Адрес',
        short: 'Короткий адрес',
    }
}

export default Address
